<div class="titulo">
    <h2>
        <p>Regístrate y comienza a <span>FIRMAR GRATIS</span></p>
    </h2>
</div>

<div class="form" id="form-account">
    <form [id]="idForm"></form>
</div>